import { ThunkAction } from 'redux-thunk';
import { RootState } from '../_reducers';
import { setUpcomingEventsError, setUpcomingEventsSuccess } from '../_actions/upcomingEvents.actions';
import { UpcomingEventsAction, UpcomingEventsRequest } from '../_types/event';
import { callOneApi, ClientSideError } from '../oneApi';

export const getUpcomingEvents = (
    data: UpcomingEventsRequest,
): ThunkAction<void, RootState, null, UpcomingEventsAction> => {
    return async (dispatch) => {
        try {
            const result = await callOneApi('GET', `/sales-channels/${data.salesChannel.id}/pass-events`);
            dispatch(setUpcomingEventsSuccess(result));
        } catch (err) {
            if (err instanceof ClientSideError) {
                dispatch(setUpcomingEventsError(err.body));
            } else {
                dispatch(setUpcomingEventsError({ message: 'Error occurred!' }));
            }
        }
    };
};
